import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class ProgressNavigationSteps extends React.Component {

    static propTypes = {
        formattedMessagesIds: PropTypes.array.isRequired,
        activeStep:           PropTypes.number
    };

    static defaultProps = {
        activeStep: 0
    };

    render() {

        return (
            <div className='progress-navigation-steps'>
                {
                    this.props.formattedMessagesIds.map((label, index) =>
                        <div className={index === this.props.activeStep ? 'step arrow-right current' :
                            index > this.props.activeStep ? 'step arrow-right not-visited' :
                                'step arrow-right visited'}
                             key={index}>
                            <FormattedMessage id={label} />
                        </div>)
                }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/ProgressNavigationSteps/ProgressNavigationSteps.jsx